<template>
    <div>
        <div style="width: 50%;margin: 20px 0;">
            <span class="searchName" >产品名称:</span>
            <el-input
                    class="mr10"
                    placeholder="名称 搜索"
                    v-model="cpinput"
                    clearable>
            </el-input>
            <el-button type="primary" @click="searchData" style="margin-left: 30px" :class="baseerp+'btn'">{{$t('button_search_for')}}</el-button>
        </div>
        <el-table
                size="mini"
                border
                ref="multipleTable"
                :data="detailsData"
                row-key="vc_unique"
                height="400"
                tooltip-effect="dark"
                :row-class-name="tableRowClassName"
                @selection-change="handleSelectionChange"
                style="width: 100%">
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_gsname"
                    :label="$t('form_company')"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    width=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_no"
                    :label="$t('form_batch_number')"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="kcsl"
                    :label="$t('form_inventory_quantity')"
                    width=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_unit"
                    :label="$t('form_metering')"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <div class="tbRight">
            <div class="paginationBox textRig" >
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="pageCurrentChange"
                        :current-page.sync="currentPage"
                        :total="tableTotal">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">

            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    //import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "ProductDetails",
        props:{
            productDetails:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                cpinput:"",
                multipleSelection:"",
                detailsData:[],
                currentPage:0,
                tableTotal:0,
                pageSize:1,
                pageCount:1,
                gsid:0,
                gsid_out:0,
                i_pzid:0,
                ckid:0,
                baseerp:"",
            }
        },
        mounted() {
            this.baseerp=baseerp;
            /*this.gsid=this.productDetails.i_gsid;
            this.ckid=this.productDetails.i_ckid;
            this.gsid_out=this.productDetails.i_gsid_out;
             this.i_pzid=this.productDetails.i_pzid;*/
            //console.log("mounted")
            //this.getFeedList();
        },
        methods: {
            //列表
            // async getFeedList(){
            //     let param={
            //         i_mid:this.mid,
            //         page_size:this.pageSize,
            //         page_count:10,
            //         vc_name:this.cpinput,
            //         i_gsid:this.productDetails.i_gsid,
            //         i_cjid:this.productDetails.i_cjid,
            //         i_ckid:this.productDetails.i_ckid,
            //         i_pzid:this.productDetails.i_pzid,
            //     };
            //     let res=await API.getFeedList(param);
            //     if(res.code==1){
            //         this.detailsData=res.data
            //     }else if (res.code == -2) {
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     }
            //     else{
            //         this.$message.error(res.message);
            //     }
            // },
            searchData(){
                this.pageSize=1;
                this.currentPage=1;
                //this.getFeedList();
            },
            cancel(){
                this.$emit('closePop');
            },

            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                //console.log(val)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }
            },
            saveForm(){
                this.$emit('transValue',this.multipleSelection);
                this.$emit('closePop');
            },
            pageCurrentChange(val){
                this.pageSize=val;
                this.currentPage=val;
                //this.getFeedList();
            },
        },
    }
</script>

<style lang="scss" scoped>
.searchName{
    width: 100px; display: inline-block;vertical-align: middle;text-align: center;
}
    .mr10{
        width: 50%;
    }

/deep/{
    .danger-row{
        color: #999;
    }
}
</style>